import type { ComponentProps } from 'react'
import { tv, type VariantProps } from 'tailwind-variants'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/tooltip'
import { getStatusInitials } from '@/utils/get-status-initials'

const sharedStyles = {
  warning: 'bg-alert-warning',
  success: 'bg-alert-success',
  danger: 'bg-alert-danger',
  monochromatic: 'bg-monochromatic-400',
  dangerDark: 'bg-alert-dangerDark',
}

const badgeVariants = tv({
  base: 'size-6 content-center text-white rounded-full text-center text-xs font-bold',
  variants: {
    variant: {
      1: sharedStyles.danger,
      2: sharedStyles.warning,
      3: sharedStyles.success,
      4: sharedStyles.dangerDark,
    },
  },
  defaultVariants: {
    variant: 1,
  },
})

export interface PaymentStatusBadgeProps
  extends VariantProps<typeof badgeVariants>,
    ComponentProps<'div'> {
  description: string
}

export function PaymentStatusBadge({
  variant,
  description,
  className,
  ...props
}: PaymentStatusBadgeProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={badgeVariants({
              variant,

              className,
            })}
            {...props}
          >
            <span>{getStatusInitials(description)}</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>{description}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
